import { createJsonMemoryAccessors } from '@/services/storage'

type MemorySlot = 'opportunities' | 'followUps' | 'reminders' | 'lostReasons' | 'timeline'

const memory: Record<MemorySlot, unknown> = {
  opportunities: null,
  followUps: null,
  reminders: null,
  lostReasons: null,
  timeline: null,
}

export const CRM_KEYS = {
  opportunities: 'masterhub.crm.opportunities.v1',
  followUps: 'masterhub.crm.followups.v1',
  reminders: 'masterhub.crm.reminders.v1',
  lostReasons: 'masterhub.crm.lost-reasons.v1',
  timeline: 'masterhub.crm.timeline.v1',
} as const

const accessors = createJsonMemoryAccessors(memory)
export const readCrmJson = accessors.readJson
export const writeCrmJson = accessors.writeJson

export function resetCrmMemory(): void {
  memory.opportunities = null
  memory.followUps = null
  memory.reminders = null
  memory.lostReasons = null
  memory.timeline = null
}

export function nowIso(): string {
  return new Date().toISOString()
}

export function daysBetween(fromIso: string, to = Date.now()): number {
  const from = new Date(fromIso).getTime()
  if (!Number.isFinite(from)) return 0
  return Math.max(0, Math.floor((to - from) / (1000 * 60 * 60 * 24)))
}

export function addDaysIso(iso: string, days: number): string {
  const date = new Date(iso)
  date.setDate(date.getDate() + days)
  return date.toISOString()
}

export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100
}
